// extracted by mini-css-extract-plugin
export default {"blur-on-hover":"Carousel_blur-on-hover__owDvU","image-container":"Carousel_image-container__-3COa","play-button":"Carousel_play-button__Tdfh3"};